import { Component } from '@angular/core';

@Component({
  selector: 'app-view-lockers-page',
  templateUrl: './view-lockers-page.component.html',
  styleUrls: ['./view-lockers-page.component.scss']
})
export class ViewLockersPageComponent {

}
